import { FileRecord } from "@/types";
import axios from "@/libs/axios.ts";

export const createContractorProjectReq = async (body: FormData) => {
  return axios.post(`/contractor/project/create`, body);
};

export const updateContractorProjectReq = async (
  projectId: number,
  body: FormData
) => {
  return axios.patch(`/contractor/project/update/${projectId}`, body);
};
